import React from 'react';
import { blogPosts } from '../mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BlogPage = () => {
  return (
    <div>
      {/* Header */}
      <section className="section-padding-small">
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Insights & Articles
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px' }}>
            Explore the science of the mind, the art of transformation, and practical guidance for living with clarity and purpose.
          </p>
        </div>
      </section>

      {/* Featured Post */}
      {blogPosts.length > 0 && (
        <section style={{ paddingBottom: '60px' }}>
          <div className="container">
            <Link to={`/blog/${blogPosts[0].id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '48px',
                alignItems: 'center'
              }} className="responsive-grid">
                <img
                  src={blogPosts[0].image}
                  alt={blogPosts[0].title}
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'cover'
                  }}
                />
                <div>
                  <span className="body-small" style={{ 
                    color: 'var(--interactive-base)', 
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginBottom: '16px',
                    display: 'block'
                  }}>
                    Featured Article
                  </span>
                  <h2 className="heading-1" style={{ marginBottom: '16px' }}>
                    {blogPosts[0].title}
                  </h2>
                  <p className="body-regular" style={{ 
                    color: 'var(--text-secondary)', 
                    marginBottom: '8px',
                    fontStyle: 'italic'
                  }}>
                    {blogPosts[0].subtitle}
                  </p>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                    {blogPosts[0].excerpt}
                  </p>
                  <span style={{
                    color: 'var(--interactive-base)',
                    fontSize: '14px',
                    fontWeight: 500,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    Read Article <ArrowRight size={14} />
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      {/* Blog Grid */}
      <section style={{ paddingBottom: '120px' }}>
        <div className="container">
          <h2 className="heading-2" style={{ marginBottom: '40px' }}>All Articles</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '32px'
          }}>
            {blogPosts.slice(1).map((post) => (
              <Link 
                key={post.id} 
                to={`/blog/${post.id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <article style={{
                  background: 'var(--bg-secondary)',
                  overflow: 'hidden',
                  height: '100%',
                  transition: 'transform 0.3s ease'
                }} className="hover-lift" data-testid={`blog-card-${post.id}`}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{
                      width: '100%',
                      height: '220px',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{ padding: '32px' }}>
                    <div style={{ marginBottom: '12px' }}>
                      <span className="body-small" style={{ color: 'var(--text-meta)' }}>
                        {new Date(post.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                    <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                      {post.title}
                    </h3>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                      {post.excerpt}
                    </p>
                    <span style={{
                      color: 'var(--interactive-base)',
                      fontSize: '14px',
                      fontWeight: 500,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      Read More <ArrowRight size={14} />
                    </span>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .hover-lift:hover {
          transform: translateY(-4px);
        }
        @media (max-width: 1024px) {
          .responsive-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default BlogPage;
